module.exports = __webpack_public_path__ + "img/indexLogo.a6b5a2f7.png";